// extracted by mini-css-extract-plugin
export default {"progress":"ProgressSelect_progress__-EbnR"};